import type { ScanValidatedCustomer } from '@dutchie-pos/requests/checkin/camera-id-scan';

/** The blockers Register applies, so a guest refused at the counter is refused here. */
type CheckInBlocker = 'banned' | 'medicalIdExpired' | 'driversLicenseExpired';

export const BLOCKER_REASONS: Record<CheckInBlocker, string> = {
  banned: 'This profile is banned.',
  medicalIdExpired: 'The medical ID has expired.',
  driversLicenseExpired: 'The driver’s licence has expired.',
};

type LocationFeatures = Record<string, boolean> | undefined;

/** A ban cannot block creation — the profile does not exist yet — but an expired document still does. */
export const createBlocker = (customer: ScanValidatedCustomer, features: LocationFeatures): CheckInBlocker | null => {
  if (customer.IsMJStateIdExpired && customer.IsMedical) {
    return 'medicalIdExpired';
  }

  return customer.IsDriversLicenseExpired && features?.RequireValidDL === true ? 'driversLicenseExpired' : null;
};

/** Everything creation blocks, plus the ban — and only where the location asked for it. */
export const checkInBlocker = (customer: ScanValidatedCustomer, features: LocationFeatures): CheckInBlocker | null =>
  customer.IsBanned && features?.BlockBannedPatientCheckin === true ? 'banned' : createBlocker(customer, features);
